import React from "react";
import { getPQRValue, getColumnClasses, bindWeldProcess } from "./pqrDataUtils";
import { pqrStyles } from "./pqrStyles";

const PQRElectricalTable = ({ pdf, type = "Groove" }) => {
  const isOverlay = type === "Overlay";
  const { colwidth, col1Class, col2Class, col3Class } = getColumnClasses(pdf,"electric");

  const electricalFields = isOverlay ? [
    { label: "Filler metal size", field: "PQRD_Electrical_FillerMetalSize", unit: "mm", isProcess: true },
    { label: "Amperes", field: "PQRD_Electrical_Amperes", unit: "Amps", isProcess: true },
    { label: "Volts", field: "PQRD_Electrical_Volts", unit: "Volts", isProcess: true },
    { label: "Travel speed", field: "PQRD_Electrical_TravelSpeed", unit: "mm/min", isProcess: true },
    { label: "Maximum heat input", field: "PQRD_Electrical_MaxHeatInput", unit: "KJ/mm", isProcess: true },
    { label: "Tungsten type & size", field: "PQRD_Electrical_TungstenType", isProcess: true },
    { label: "Current/polarity", field: "PQRD_Electrical_CurrentPolarity", isProcess: true },
    { label: "DC pulsing current", field: "PQRD_Electrical_DCPulsatingCurrent", isProcess: true },
    { label: "Wire Feed Type", field: "PQRD_Electrical_WireFeedType", isProcess: true },
    { label: "Wire Feed Speed", field: "PQRD_Electrical_WireFeedSpeed", unit: "m/min", isProcess: true, isLast: true }
  ] : [
    { label: "Filler metal size(\u00D8)", field: "PQRD_Electrical_FillerMetalSize", unit: "mm", isProcess: true },
    { label: "Amperes", field: "PQRD_Electrical_Amperes", unit: "Amps", isProcess: true },
    { label: "Voltage", field: "PQRD_Electrical_Volts", unit: "Volts", isProcess: true },
    { label: "Travel speed", field: "PQRD_Electrical_TravelSpeed", unit: "mm/min", isProcess: true },
    { label: "Minimum bead Length (SMAW)", field: "PQRD_Electrical_minBeadLength", unit: "mm", isProcess: true },
    { label: "Arc Transfer Mode (FCAW/GMAW)", field: "PQRD_Electrical_ArcTransferMode", isProcess: true },
    { label: "Maximum heat input", field: "PQRD_Electrical_MaxHeatInput", unit: "KJ/mm", isProcess: true },
    { label: "Tungsten type & size", field: "PQRD_Electrical_TungstenType", isProcess: true },
    { label: "Current/polarity", field: "PQRD_Electrical_CurrentPolarity", isProcess: true },
    { label: "DC pulsing current", field: "PQRD_Electrical_DCPulsatingCurrent", isProcess: true, isLast: true }
  ];

  return (
    <>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal">ELECTRICAL(QW- 409)</div>
      </div>
      <div style={pqrStyles.container}>
        <table id="table" className="PQRTable2" cellSpacing="0" style={{borderTop:"1px solid black"}}>
          <tbody>
            {electricalFields.map((field, index) => {
              const isFirst = index === 0;
              const className = field.isLast ? "PQRtrhide PQR_Botmrt" : "PQRtrhide PQR_right";
              
              let thClassName;
              if (field.isLast) {
                thClassName = "PQRthhide2 PQR_noTop";
              } else if (isFirst) {
                thClassName = "PQRfillerMetalth PQR_noBotm";
              } else {
                thClassName = "PQRfillerMetalth PQR_rt_lft";
              }

              return (
                <tr key={field.field} className={className}>
                  <th className={thClassName} style={isFirst ? { width: "27%" } : {}}>
                    {field.label}
                    {field.unit && <div className="PQRrcorner"> {field.unit}</div>}
                  </th>
                  <td className={col1Class} style={{ width: colwidth }}>
                    {field.isProcess ? bindWeldProcess(pdf, field.field, 1) : getPQRValue(pdf[1]?.[field.field])}
                  </td>
                  <td className={col2Class} style={{ width: colwidth }}>
                    {field.isProcess ? bindWeldProcess(pdf, field.field, 2) : getPQRValue(pdf[2]?.[field.field])}
                  </td>
                  <td className={col3Class} style={{ width: colwidth }}>
                    {field.isProcess ? bindWeldProcess(pdf, field.field, 3) : getPQRValue(pdf[3]?.[field.field])}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PQRElectricalTable;